module.exports = __webpack_public_path__ + "img/sandramolenaar.1d473150.jpeg";